import { DisplayOptionsGraphQL } from '~/types/DisplayOptionsGraphQL';

/**
 * Builds a array of CSS classes to control how a component is displayed based on its display options.
 *
 * @param      {Array}  displayOptions  The display options.
 * @return     {Array}  The corresponding CSS classes.
 */
export function useGetDisplayOptionsClassesGraphQL(displayOptions?: DisplayOptionsGraphQL[]) {
  const classes = {};
  if (displayOptions) {
    displayOptions.forEach((displayOption) => {
      if (displayOption?.type === 'style') {
        const fieldName = getProperElement(displayOption.scope);
        if (classes.hasOwnProperty(fieldName)) {
          classes[fieldName] += ' ' + displayOption.value;
        } else {
          classes[fieldName] = displayOption.value;
        }
      }
    });
  }

  return classes;
}

/**
 * Gets the proper element name based on the component scope.
 *
 * @param      {string}  scope   The scope
 * @return     {string}  The proper element.
 */
function getProperElement(scope) {
  switch (scope) {
    case 'title':
      return 'title';
    case 'block':
      return 'block';
    case 'description':
      return 'description';
    case 'background':
      return 'background';
    case 'image':
      return 'image';
    case 'item-text':
      return 'itemtext';
    default:
      return 'container';
  }
}
